var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TourStepsTemplate',{class:`report-intro-part report-intro-partV2__step-${_vm.reportIntroStep}`,attrs:{"callbacks":_vm.myCallbacks,"steps":_vm.steps,"tour-name":"reportIntroV2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }